// @flow
import { of } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { getWishListsApi } from './api';
import { ofType } from 'redux-observable';
import update from 'immutability-helper';

import type { Observable } from 'rxjs';
import type { WishList } from '../../entities';
import type { HTTPError } from '../../error';

export type WishListCatalogAction = {
  +type: string;
  +wishLists?: WishList[];
  +error?: HTTPError;
};

export type WishListCatalogState = {
  isFetchingWishLists?: boolean;
  wishLists?: WishList[];
  fetchWishListsError?: HTTPError;
};

// Actions
const WISH_LIST_CATALOG_FETCH_WISH_LISTS_REQUEST = 'WISH_LIST_CATALOG_FETCH_WISH_LISTS_REQUEST';
const WISH_LIST_CATALOG_FETCH_WISH_LISTS_SUCCESS = 'WISH_LIST_CATALOG_FETCH_WISH_LISTS_SUCCESS';
const WISH_LIST_CATALOG_FETCH_WISH_LISTS_ERROR = 'WISH_LIST_CATALOG_FETCH_WISH_LISTS_ERROR';

const WISH_LIST_CATALOG_RESET_STATE = 'WISH_LIST_CATALOG_RESET_STATE';

// Action Creators
export function fetchWishLists(): WishListCatalogAction {
  return {
    type: WISH_LIST_CATALOG_FETCH_WISH_LISTS_REQUEST,
  };
}

export function fetchWishListsSuccess(wishLists: WishList): WishListCatalogAction {
  return {
    type: WISH_LIST_CATALOG_FETCH_WISH_LISTS_SUCCESS,
    wishLists,
  };
}

export function fetchWishListsErrorFn(error: HTTPError): WishListCatalogAction {
  return {
    type: WISH_LIST_CATALOG_FETCH_WISH_LISTS_ERROR,
    error,
  };
}

export function resetState() {
  return {
    type: WISH_LIST_CATALOG_RESET_STATE,
  };
}

export const actions = {
  WISH_LIST_CATALOG_FETCH_WISH_LISTS_REQUEST,
  WISH_LIST_CATALOG_FETCH_WISH_LISTS_SUCCESS,
  WISH_LIST_CATALOG_FETCH_WISH_LISTS_ERROR,
  WISH_LIST_CATALOG_RESET_STATE,
  fetchWishLists,
  fetchWishListsSuccess,
  fetchWishListsErrorFn,
  resetState,
};

export const initialState: WishListCatalogState = {};

// Reducer
export default function reducer(state: WishListCatalogState = initialState,
                                action: WishListCatalogAction): WishListCatalogState {
  switch (action.type) {
    case WISH_LIST_CATALOG_FETCH_WISH_LISTS_REQUEST:
      return update(state, {
        isFetchingWishLists: { $set: true },
        $unset: ['fetchWishListsError'],
      });
    case WISH_LIST_CATALOG_FETCH_WISH_LISTS_SUCCESS:
      return update(state, {
        $unset: ['isFetchingWishLists'],
        wishLists: { $set: action.wishLists },

      });
    case WISH_LIST_CATALOG_FETCH_WISH_LISTS_ERROR:
      return update(state, {
        $unset: ['isFetchingWishLists'],
        fetchWishListsError: { $set: action.error },
      });
    case WISH_LIST_CATALOG_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function fetchWishListsEpic(action$: Observable<WishListCatalogAction>) {
  return action$.pipe(
    ofType(WISH_LIST_CATALOG_FETCH_WISH_LISTS_REQUEST),
    mergeMap(() => getWishListsApi({
      itemsSort: 'UPDATED_AT',
      itemsOrder: 'DESC',
    }).pipe(
      map((wishLists: WishList[]) => fetchWishListsSuccess(wishLists)),
      catchError((e: HTTPError) => of(fetchWishListsErrorFn(e))),
    )),
  );
}



// WEBPACK FOOTER //
// ./src/modules/wish-list-catalog/duck.js